import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  deletingContentId: '',
  error: {
    title: '',
    status: '',
    description: '',
  },
  message: {
    title: '',
    description: '',
  },
  page: {},
};

const structureProgramSlice = createSlice({
  name: 'structureProgram',
  initialState,
  reducers: {
    GET_CONTENT: state => ({
      ...state,
      isLoading: true,
    }),
    GET_CONTENT_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      page: payload.page,
    }),
    GET_CONTENT_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    UPDATE_DATA: state => ({
      ...state,
      isLoading: true,
      error: initialState.error,
      message: initialState.message,
    }),
    UPDATE_DATA_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      message: payload.message,
      error: initialState.error,
    }),
    UPDATE_DATA_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    DELETE_CONTENTS: (state, { payload }) => ({
      ...state,
      isDeletingContent: true,
      deletingContentId: payload.idContent,
    }),
    DELETE_CONTENTS_SUCCESS: state => ({
      ...state,
      isDeletingContent: false,
      deletingContentId: '',
    }),
    UPDATE_MODULES: state => ({ ...state }),
    SAVE_MODULES: state => ({ ...state }),
    UPDATE_CONTENTS: state => ({ ...state }),
    SAVE_CONTENTS: state => ({ ...state }),
    DELETE_MODULES: state => ({ ...state }),
    RESET_MESSAGES: state => ({
      ...state,
      message: { ...initialState.message },
      error: { ...initialState.error },
    }),
    RESET_STATE: () => ({ ...initialState }),
  },
});

export const {
  GET_CONTENT,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_FAIL,
  UPDATE_DATA,
  UPDATE_DATA_SUCCESS,
  UPDATE_DATA_FAIL,
  UPDATE_CONTENTS,
  UPDATE_MODULES,
  SAVE_CONTENTS,
  SAVE_MODULES,
  DELETE_MODULES,
  DELETE_CONTENTS,
  DELETE_CONTENTS_SUCCESS,
  RESET_MESSAGES,
  RESET_STATE,
} = structureProgramSlice.actions;

export const structureProgramSelector = state => state.structureProgram;

export default structureProgramSlice.reducer;
